import { render, staticRenderFns } from "./SyncPokedex.vue?vue&type=template&id=b0b156a0&scoped=true&lang=pug&"
import script from "./SyncPokedex.vue?vue&type=script&lang=js&"
export * from "./SyncPokedex.vue?vue&type=script&lang=js&"
import style0 from "./SyncPokedex.vue?vue&type=style&index=0&id=b0b156a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b156a0",
  null
  
)

export default component.exports